export function currentExtension(state = null, action) {
	switch (action.type) {
		case 'SWITCH_EXTENSION':
			return JSON.parse(JSON.stringify(action.extension))
		default:
			return state
	}
}

export function isFaxConfigured(state = null, action) {
	switch (action.type) {
		case 'SET_IS_FAX_CONFIGURED':
			return action.isFaxConfigured
		default:
			return state
	}
}